import { gql } from '@apollo/client';

export const GET_USERS_QUERY = gql`
  query getUsersQuery($get_deleted: Boolean) {
    users(get_deleted: $get_deleted) {
      id
      created
      modified
      deleted
      first_name
      last_name
      email
      phone
      super_admin
      groups
      type
      last_accessed
    }
  }
`;

export const GET_USER_DETAILS_QUERY = gql`
  query getUserDetailsQuery($user_id: String) {
    user_details(user_id: $user_id) {
      id
      created
      modified
      deleted
      first_name
      last_name
      email
      phone
      super_admin
      groups
      type
      last_accessed
    }
  }
`;
